export type ThemeMode = 'dark' | 'light'

export const THEME_MODE_STORAGE_KEY = 'onyxia-theme-mode'

export const isThemeSwitcherEnabled = process.env.REACT_APP_ENABLE_THEME_SWITCHER === 'true'

const DEFAULT_MODE: ThemeMode = 'dark'

// Read the persisted preference. Falls back to dark when the switcher is off,
// nothing is stored, or storage is unavailable (private mode, SSR, etc.).
export const getInitialThemeMode = (): ThemeMode => {
  if (!isThemeSwitcherEnabled) return DEFAULT_MODE
  try {
    return localStorage.getItem(THEME_MODE_STORAGE_KEY) === 'light' ? 'light' : DEFAULT_MODE
  } catch {
    return DEFAULT_MODE
  }
}

// Current mode from the <html data-theme> attribute, for JS/D3 consumers where
// CSS var() doesn't resolve (SVG fill/stroke, canvas).
export const getActiveThemeMode = (): ThemeMode =>
  typeof document !== 'undefined' && document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark'

// Reflect the mode onto <html data-theme> so the CSS variables resolve, and
// persist it. Persistence is skipped while the switcher is off.
export const applyThemeMode = (mode: ThemeMode): void => {
  document.documentElement.setAttribute('data-theme', mode)
  if (!isThemeSwitcherEnabled) return
  try {
    localStorage.setItem(THEME_MODE_STORAGE_KEY, mode)
  } catch {
    /* storage unavailable — preference simply won't persist this session */
  }
}
